import React from 'react'
import RealTime from './RealTime'
import { useQueryClient } from '@tanstack/react-query'

const RTTasks = () => {
  const queryClient = useQueryClient()

  const handleEvent = ({ action, subject, data }) => {
    queryClient.invalidateQueries({ queryKey: ['Tasks'] })
  }

  return <RealTime channel="Tasks::TasksChannel" onEvent={handleEvent} />
}

export default RTTasks
